import { Treatment } from "../screens/treatments/treatment-prescription/types";
import { getArrayElementByDateProperty } from "./dateUtils";

export const getClientCurrentTreatment = (treatments: Array<Treatment>) => {
	const activeTreatments = treatments.filter((treatment) => treatment?.treatment_status_new === "all_good")
	if (activeTreatments) {
		return getArrayElementByDateProperty(treatments, "date_of_start", true)
	}
	return false
};